import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Badge } from "V2.0/common/badge";
import { getModelName } from "../../ModelSettings/GPTResponseModelCategorized/GPTResponsePremiumModel";

export default EvalRunReportModelRankings;

function EvalRunReportModelRankings(props) {
  const { modelRankings } = props;

  return (
    <div className="space-y-4">
      <p className="text-sm font-semibold">Model Rankings</p>
      <div className="border rounded-lg w-2/4">
        <Table className="">
          <TableHead>
            <TableHeader>Model</TableHeader>
            <TableHeader>Average Score</TableHeader>
          </TableHead>
          <TableBody>
            {modelRankings.map((modelRanking, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>
                    <Badge>{getModelName(modelRanking.model)}</Badge>
                  </TableCell>
                  <TableCell>{modelRanking.avgScore}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
